import type { TEventWithDateRange } from 'App/irrigation-scheduler/utils/store/types'
import type moment from 'moment-timezone'
import { calculateDurationInWindow } from './calculateDurationInWindow'

export const sumEventDurationsInWindow = <T extends TEventWithDateRange>(
  events: T[],
  windowStart: moment.Moment,
  windowEnd: moment.Moment,
): number => {
  return events.reduce((sum, event) => {
    return sum + calculateDurationInWindow(event, windowStart, windowEnd)
  }, 0)
}
